import ClassicBuilder from './classic-builder';
import ShowdownBuilder from './showdown-builder';
import TiersBuilder from './tiers-builder';
import PlayerBuilderInterface from 'components/organisms/players-to-exchange/available-players/player-builder-interface';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';

export default class BuilderFactory implements PlayerBuilderInterface {
    createClassicBuilder(sportConfig): BuilderInterface {
        return new ClassicBuilder(sportConfig);
    }

    createTiersBuilder(sportConfig): BuilderInterface {
        return new TiersBuilder(sportConfig);
    }

    createShowDownBuilder(sportConfig): BuilderInterface {
        return new ShowdownBuilder(sportConfig);
    }

    createSingleGameBuilder(sportConfig): BuilderInterface {
        return new ShowdownBuilder(sportConfig);
    }
}
